import { findAncestor } from '../../utils/dom';
import { throttle } from 'throttle-debounce';


export const clickToOpenMegaNav = (): void => {

  const loadNavAdvertVideos = (root: Element) => {
    const videoContainers = root.querySelectorAll<HTMLElement>('[data-nav-advert-video]');

    videoContainers.forEach(container => {

      const existingIframe = container.querySelector<HTMLIFrameElement>('iframe');
      if (existingIframe) {
        const currentSrc = existingIframe.getAttribute('src');
        const lazySrc = existingIframe.getAttribute('data-src');
        if ((!currentSrc || currentSrc === 'about:blank') && lazySrc) {
          existingIframe.setAttribute('src', lazySrc);
        }
      }

      if (container.dataset.videoLoaded === 'true') return;

      const src = container.dataset.videoSrc;
      if (!src) return;

      const iframe = document.createElement('iframe');
      iframe.src = src;
      iframe.setAttribute('title', 'Navigation video');
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture; encrypted-media');
      iframe.setAttribute('allowfullscreen', 'true');
      iframe.setAttribute('muted', 'true');
      iframe.setAttribute('playsinline', 'true');
      iframe.setAttribute('aria-hidden', 'true');

      container.appendChild(iframe);
      container.dataset.videoLoaded = 'true';

      const advert = container.closest('.nav-advert');
      if (advert) {
        advert.classList.add('nav-advert--video-loaded');
      }
    });
  };

  const isTouchDevice = () : boolean => {
    return 'ontouchstart' in window        // works on most browsers
    || 'onmsgesturechange' in window;  // works on IE10 with some false positives
  };

  const navToggles = document.querySelectorAll('[data-nav-toggle]');
  if (navToggles.length <= 0) return;

  const classToToggle = 'menu-open';

  const hoverUnderlays = document.querySelectorAll('[data-nav-hover-underlay]');

  const closeAllMeganavs = () =>
    document.querySelectorAll('[data-nav-item]').forEach(t => t.classList.remove(classToToggle));

  navToggles.forEach(navToggle => {
    navToggle.addEventListener('click', (e) => {
      if (window.matchMedia('(min-width: 1024px)').matches) {
        if (isTouchDevice()) {
          //don't follow links on touch devices
          e.preventDefault()
          return false;
        }
        //just do the click
        return true
      }
      const parent = findAncestor((<HTMLElement>e.target), 'navItem');
      if (parent) {
        e.preventDefault()
        if (!parent.classList.contains(classToToggle)) {
          // Closing all mega navs
          closeAllMeganavs()
        }

        // Toggle this mega nav
        parent.classList.toggle(classToToggle);

        if (parent.classList.contains(classToToggle)) {
          loadNavAdvertVideos(parent);
        }
      }
      return false;
    });
  });

  hoverUnderlays.forEach(hoverUnderlay => {
    const navItem = findAncestor((<HTMLElement>hoverUnderlay), 'navItem');
    hoverUnderlay.addEventListener('mouseenter', () => navItem.classList.add('hover-underlay-closing'))
    navItem.addEventListener('mouseenter', () => {
      navItem.classList.remove('hover-underlay-closing');
      loadNavAdvertVideos(navItem);
    })
  })

  document.querySelectorAll('[data-nav-item-has-children]').forEach(navItem => {
    navItem.addEventListener('focusin', () => {
      loadNavAdvertVideos(navItem);
    });
  });

  document.querySelectorAll('[data-nav-btn-back]').forEach(btn =>
    btn.addEventListener('click', () => {
      // Closing all mega navs
      closeAllMeganavs();
    })
  );

  const tabIndexSwap = () => {
    const tabIndexMob = document.querySelectorAll('[data-tabindex-swap="mobile"]');
    const tabIndexDes = document.querySelectorAll('[data-tabindex-swap="desktop"]');

    if (window.innerWidth < 768) {
      tabIndexMob.forEach(el => {
        el.setAttribute('tabIndex', '0');
      });
      tabIndexDes.forEach(el => {
        el.setAttribute('tabIndex', '-1');
      });
    } else {
      tabIndexMob.forEach(el => {
        el.setAttribute('tabIndex', '-1');
      });
      tabIndexDes.forEach(el => {
        el.setAttribute('tabIndex', '0');
      });
    }
  }

  tabIndexSwap();

  window.addEventListener('resize', throttle(500, false, () => {
    tabIndexSwap();
  }));
}
